export default class BaseUpdateRequest {
    id: string;
    updatedAt: Date;
}
